<template>
  <div>
    <!-- 밀폐공간작업 상세정보 -->
    <c-card title="LBL0000271" class="cardClassDetailForm no-margin">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <!-- 출입사유 -->
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000272"
            name="closeEntryResaon"
            v-model="supWork.closeEntryResaon"
            @dataChange="dataChange">
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <!-- 밀폐장소의 예상위험 -->
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000273"
            name="closeExpectedRisk"
            v-model="supWork.closeExpectedRisk"
            @dataChange="dataChange">
          </c-textarea>
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <!-- 안전조치 요구사항 -->
        <c-table
          class="q-mt-md"
          title="LBL0000232"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="supWork.checkResults"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable&&isWriting"
          :contentsField="contentsField"
          @table-data-change="tableDataChange"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <c-table
          ref="entrantTable"
          class="q-mt-md"
          title="입출입자"
          :columns="gridEnter.columns"
          :gridHeight="gridEnter.height"
          :data="supWork.entrants"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable&&isWriting"
          selection="multiple"
          rowKey="sopWorkEntrantId"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable&&isWriting" label="추가(외부)" icon="add" :showLoading="false" @btnClicked="addEntrantVendor" />
              <c-btn v-if="editable&&isWriting" label="추가(임직원)" icon="add" :showLoading="false" @btnClicked="addEntrant" />
              <c-btn v-if="editable&&isWriting" label="제외" icon="remove" :showLoading="false" @btnClicked="removeEntrant" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name==='deptUserName'">
              <template v-if="Boolean(props.row.userId)">
                {{ props.row[col.name] }}
              </template>
              <template v-else>
                <c-text-column
                  :editable="editable"
                  :disabled="!isWriting"
                  :col="col"
                  :props="props"
                  @datachange="entrantDataChange(props)"
                />
              </template>
            </template>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <!-- 가스농도 측정 -->
        <c-table
          ref="gasTable"
          class="q-mt-md"
          title="LBL0000236"
          :columns="grid2.columns"
          :gridHeight="grid2.height"
          :data="supWork.gases"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable&&isWriting"
          selection="multiple"
          rowKey="sopGasCheckId"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 추가 -->
              <c-btn v-if="editable&&isWriting" label="LBL0000253" icon="add" :showLoading="false" @btnClicked="addGas" />
              <!-- 제외 -->
              <c-btn v-if="editable&&isWriting" label="LBL0000275" icon="remove" :showLoading="false" @btnClicked="removeGas" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <!-- <div v-if="editable&&isWriting" class="alert alert-info alert-dismissible fade show cursor-pointer" 
      style="margin-bottom:13px !important; padding: 10px 3px !important" role="alert"
      v-on:click="setPermitData">
      <span class="q-pl-sm q-pr-md">
        <q-icon name="o_emoji_objects" size="sm" />
      </span>
      <q-chip dense color="teal" text-color="white">
        {{$comm.getLangLabel('LBL0000242', 'SWP')}}
      </q-chip>
      <q-chip dense color="teal" text-color="white">
        {{$comm.getLangLabel('LBL0000268', 'SWP')}}
      </q-chip>
      <q-chip dense color="teal" text-color="white">
        {{$comm.getLangLabel('LBL0000317', 'SWP')}}
      </q-chip>
        {{$comm.getLangLabel('LBL0000269', 'SWP')}}
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="LBL0000241" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field 
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="issuedDeptCd"
                type="dept_user" 
                label="LBL0000242" 
                beforeText=""
                name="userId1" 
                v-model="supWork.issuedUserId"
                @dataChange="dataChange" />
            </div>
            <div class="col-6">
              <c-field 
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="approvalDeptCd"
                type="dept_user" 
                label="LBL0000243"
                beforeText=""
                name="userId2" 
                v-model="supWork.approvalUserId"
                @dataChange="dataChange" />
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="LBL0000244" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="relationCooperation1DeptCd"
                type="dept_user"
                label="LBL0000245"
                beforeText=""
                name="relationCooperation1UserId"
                v-model="supWork.relationCooperation1UserId"
                @dataChange="dataChange" />
            </div>
            <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="relationCooperation2DeptCd"
                type="dept_user"
                label="LBL0000246"
                beforeText=""
                name="relationCooperation2UserId"
                v-model="supWork.relationCooperation2UserId"
                @dataChange="dataChange" />
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="LBL0000247" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="maintenanceDeptCheckDeptCd"
                type="dept_user"
                label="LBL0000248"
                name="maintenanceDeptCheckUserId"
                v-model="supWork.maintenanceDeptCheckUserId"
                @dataChange="dataChange" />
            </div>
            <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="supWork"
                deptValue="maintenanceDeptEntryDeptCd"
                type="dept_user"
                label="LBL0000249"
                name="maintenanceDeptEntryUserId"
                v-model="supWork.maintenanceDeptEntryUserId"
                @dataChange="dataChange" />
            </div>
          </template>
        </c-card>
      </div>
    </div> -->
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';

export default {
  name: 'swp-confined-space',

  props: {
    workPermit: {
      type: Object,
      default: function() {
        return {
          sopWorkPermitId: '',  // 작업허가서 일련번호
          swpStepCd: '',  // 진행단계 코드
        }
      }
    },
    supWork: {
      type: Object,
      default: function() {
        return {
          sopWorkPermitId: '',  // 작업허가서 일련번호
          supplementWorkTypeCd: '',  // 보충작업구분
          workProposalNo: '',  // 작업 신청번호_방사선, 고소, 중장비
          workLocation: '',  // 작업장소_방사선, 고소, 중장비
          workSummary: '',  // 작업개요_고소, 방사선,굴착, 중장비
          issuedDeptCd: '',  // 발급자 부서코드
          issuedUserId: '',  // 발급자 ID
          approvalDeptCd: '',  // 승인자 부서코드
          approvalUserId: '',  // 승인자 ID
          maintenanceDeptCheckUserId: '',  // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: '',  // 정비부서 입회자 - 안전조치확인
          relationCooperation1DeptCd: '',  // 관려부서 협조자1 부서코드
          relationCooperation1UserId: '',  // 관련부서 협조자1 ID
          relationCooperation2DeptCd: '',  // 관려부서 협조자2 부서코드
          relationCooperation2UserId: '',  // 관련부서 협조자2 ID
          specialRequirements: '',  // 특별요구사항
          closeMachine: '',  // (밀폐)장치명
          closeEntryResaon: '',  // (밀폐)출입사유
          closeEntryUserIds: '',  // (밀폐)출입자id_구분자이용 복수등록
          closeEntryUserNames: '',  // (밀폐)출입자명_구분자이용 복수등록
          closeExpectedRisk: '',  // (밀폐)예상위험
          blackoutCircuitBreaker: '',  // (정전)차단기기
          blackoutCircuitBreakerNo: '',  // (정전)차단기 번호
          blackoutPowerRecoveryRequestUserId: '',  // (정전)전원복구 요청자
          blackoutPowerRecoveryTime: '',  // (정전)전원복구 시간
          blackoutElectricBlockUserId: '',  // (정전)차단확인자(전기)
          blackoutMaintenanceBlockUserId: '',  // (정전)차단확인자(정비)
          radiationResponsibleUserId: '',  // (방사선)방사능 책임자
          heavyEquipSafetyCheckUserId: '',  // (중장비)안전조치 확인자
          heavyEquipManageUserId: '',  // (중장비)장비관리 책임자
          heavyEquipDriveUserId: '',  // (중장비)운전원
          heavyEquipDirectorRequirements: '',  // (중장비) 감독 요구사항
          heavyEquipRequireDeptRequirements: '',  // (중장비)요청부서 요구사항
          heavyEquipSupportDeptRequirements: '',  // (중장비) 지원부서 요구사항
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          checkResults: [], // 안전조치항목
          gases: [], // 가스항목측정 ** 사용하지 않는 보충작업도 존재하지만 빈 배열을 할당시켜 관리
          gasChecks: [], // 저장용
          gasCheckVals: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          editFlag: 'C',
          entrants: [],
          deleteEntrants: [],
        }
      }
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
    saveAction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: '450px'
      },
      grid2: {
        columns: [],
        height: '450px'
      },
      gridEnter: {
        columns: [
          {
            name: 'deptUserName',
            field: 'deptUserName',
            label: '소속 / 이름',
            align: 'center',
            sortable: true,
            type: 'custom'
          },
        ],
        height: '450px'
      },
      useGasItems: [],
      editable: true,
      listCheckItemUrl: '',
      listGasItemUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
    'workPermit.plantCd'() {
      this.$set(this.supWork, 'checkResults', [])
      this.$set(this.supWork, 'gases', [])
      this.getCheckItemList();
      this.getGasItemList();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listCheckItemUrl = selectConfig.sop.swp.workChekItem.list.url
      this.listGasItemUrl = selectConfig.sop.swp.gas.list.url
      // code setting
      // list setting
      this.getCheckItemList();
      this.getGasItemList();
    },
    getCheckItemList() {
      /**
       * default 값을 조회
       * 
       * 초기인 경우 workPermit.checkResults에 값을 그대로 적용
       * 작성중 단계인 경우 default 값에 새로운 항목이 있을시에 workPermit.checkResults에 추가하여 입력을 받을 수 있도록 조치
       * 승인완료, 연장, 취소, 작업완료인 경우 저장된 데이터를 그대로 표시하며 이 경우 default값을 조회하지 않도록 조치
       */
      this.grid.columns = [
        // 항목
        {
          name: 'checkItemName',
          field: 'checkItemName',
          label: 'LBL0000233',
          align: 'left',
          sortable: true,
        },
        // 필요
        {
          name: 'necessaryFlag',
          field: 'necessaryFlag',
          label: 'LBL0000234',
          align: 'center',
          sortable: false,
          type: 'check',
          'true': 'Y',
          'false': 'N',
          value: 'N',
          setHeader: true,
        },
        // 확인
        {
          name: 'confirmFlag',
          field: 'confirmFlag',
          label: 'LBL0000235',
          align: 'center',
          sortable: false,
          type: 'check',
          disableTarget: 'necessaryFlag',
          disableCon: 'Y',
          'true': 'Y',
          'false': 'N',
          value: 'N',
          setHeader: true,
        },
      ]
      if (!this.workPermit.plantCd) return;
      if (!this.supWork.checkResults) this.supWork.checkResults = [];
      if (!this.isOld || this.workPermit.swpStepCd === 'SS00000001') {
        this.$http.url = this.listCheckItemUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
          sopWorkTypeCd: 'SWT0000010',
          useFlag: 'Y',
        }
        this.$http.request((_result) => {
          if (!this.isOld && (!this.supWork.checkResults || this.supWork.checkResults.length === 0)) {
            // 최초인 경우 조치항목을 가지고 있지 않음으로 해당 값을 표시
            this.$_.forEach(_result.data, item => {
              this.supWork.checkResults.push({
                sopWorkPermitId: '',  // 작업허가서 일련번호
                supplementWorkTypeCd: this.supWork.supplementWorkTypeCd,  // 보충작업구분
                sopCheckItemId: item.sopCheckItemId,  // 점검항목 일련번호
                checkItemName: item.checkItemName, // 점검항목명
                sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                necessaryFlag: 'N',  // 필요
                confirmFlag: 'N',  // 확인
                confirmUserId: '',  // 확인자
                confirmUserName: '',  // 확인자명
                resultContents: '',
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                chgUserId: '',  // 수정자 ID
                editFlag: 'C'
              })
            })
          } else {
            this.$_.forEach(_result.data, item => {
              if (this.$_.findIndex(this.supWork.checkResults, { sopCheckItemId: item.sopCheckItemId }) === -1) {
                this.supWork.checkResults.push({
                  sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                  supplementWorkTypeCd: this.supWork.supplementWorkTypeCd,  // 보충작업구분
                  sopCheckItemId: item.sopCheckItemId,  // 점검항목 일련번호
                  checkItemName: item.checkItemName, // 점검항목명
                  sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                  necessaryFlag: 'N',  // 필요
                  confirmFlag: 'N',  // 확인
                  confirmUserId: '',  // 확인자
                  confirmUserName: '',  // 확인자명
                  resultContents: '',
                  regUserId: this.$store.getters.user.userId,  // 등록자 ID
                  chgUserId: '',  // 수정자 ID
                  editFlag: 'C'
                })
              }
            })
          }
          
          // 확인자
          if (this.$_.findIndex(_result.data, { sopCheckItemKindCd: 'SCIK000005' }) > -1 
            || this.$_.findIndex(this.supWork.checkResults, { sopCheckItemKindCd: 'SCIK000005' }) > -1) {
            this.grid.columns.push({
              name: 'confirmUserName',
              field: 'confirmUserName',
              label: '점검자',
              align: 'center',
              sortable: true,
              type: 'user',
              userId: 'confirmUserId',
              disableTarget: 'necessaryFlag',
              disableCon: 'Y',
            })
          } else if (this.$_.findIndex(_result.data, { sopCheckItemKindCd: 'SCIK000010' }) > -1 
            || this.$_.findIndex(this.supWork.checkResults, { sopCheckItemKindCd: 'SCIK000010' }) > -1) {
            this.grid.columns.push({
              name: 'resultContents',
              field: 'resultContents',
              label: '확인(입력)',
              align: 'left',
              sortable: true,
              type: 'text',
              style: 'width:350px',
              disableTarget: 'necessaryFlag',
              disableCon: 'Y',
            })
          }
        },);
      } else {
        if (this.$_.findIndex(this.workPermit.checkResults, { sopCheckItemKindCd: 'SCIK000005' }) > -1) {
          this.grid.columns.push({
            name: 'confirmUserName',
            field: 'confirmUserName',
            label: '점검자',
            align: 'center',
            sortable: true,
            type: 'user',
            userId: 'confirmUserId',
            disableTarget: 'necessaryFlag',
            disableCon: 'Y',
          })
        } else if (this.$_.findIndex(this.workPermit.checkResults, { sopCheckItemKindCd: 'SCIK000010' }) > -1) {
          this.grid.columns.push({
            name: 'resultContents',
            field: 'resultContents',
            label: '확인(입력)',
            align: 'left',
            sortable: true,
            type: 'text',
            style: 'width:350px',
            disableTarget: 'necessaryFlag',
            disableCon: 'Y',
          })
        } 
      }
    },
    getGasItemList() {
      this.grid2.columns = [
        // 측정시간
        {
          name: 'checkTime',
          field: 'checkTime',
          label: '측정시간',
          align: 'center',
          type: 'datetime',
          minuteStep: 10,
          sortable: false,
          style: 'width:80px',
        },
        // 점검기기
        // {
        //   name: 'gasCheckMachine',
        //   field: 'gasCheckMachine',
        //   label: 'LBL0000238',
        //   align: 'center',
        //   sortable: false,
        //   type: 'text',
        //   value: '',
        //   setHeader: true,
        //   style: 'width:80px',
        // },
        // 측정자
        {
          name: 'gasCheckUserName',
          field: 'gasCheckUserName',
          label: '측정자',
          align: 'center',
          sortable: false,
          type: 'user',
          userId: 'gasCheckUserId',
          value: '',
          setHeader: true,
          style: 'width:80px',
        },
        // 확인자
        {
          name: 'gasConfirmUserName',
          field: 'gasConfirmUserName',
          label: '확인자',
          align: 'center',
          sortable: false,
          type: 'user',
          userId: 'gasConfirmUserId',
          value: '',
          setHeader: true,
          style: 'width:80px',
        },
      ];

      this.$http.url = this.listGasItemUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.workPermit.plantCd,
        // sopWorkTypeCd: 'SWT0000010',
      }
      this.$http.request((_result) => {
        this.useGasItems = [];
        if (this.supWork.gases && this.supWork.gases.length > 0) {
          let pushData = [];
          this.$_.forEach(this.supWork.gases, gas => {
            for (let gasValue in gas) {
              let idx = this.$_.findIndex(_result.data, { sopGasId: gasValue });
              let idx2 = this.$_.findIndex(pushData, { sopGasId: gasValue });
              /**
               * idx의 경우 기본적으로 존재하는지 여부를 판단하지만
               *            예전 입력된 값 중 useFlag N처리된 값이 있는 경우는 허용
               */
              if ((idx > -1 && gas[gasValue] !== '-') && idx2 === -1) {
                this.$set(_result.data[idx], 'me')
                pushData.push(_result.data[idx])
              }
            }
          })
          if (pushData && pushData.length > 0) {
            this.$_.forEach(pushData, item => {
              this.useGasItems.push(item)
              this.grid2.columns.splice(1, 0, {
                // 가스 헤더 적용 로직 추가 필요
                name: item.sopGasId + '_p',
                field: item.sopGasId + '_p',
                label: item.gasName,
                align: 'center',
                sortable: false,
                child: [
                  {
                    name: item.sopGasId,
                    field: item.sopGasId,
                    label: item.safetyStandards,
                    align: 'center',
                    type: 'text',
                    sortable: false,
                    style: 'width:80px',
                  },
                ]
              })
            })
          }
        } else {
          let useYList = this.$_.filter(_result.data, item => {
            return item.useFlag === 'Y' && this.$_.findIndex(item.workTypes, { sopWorkTypeCd: 'SWT0000010' }) > -1
          });
          this.$_.forEach(useYList, gas => {
            this.useGasItems.push(gas)
            this.grid2.columns.splice(1, 0, {
              // 가스 헤더 적용 로직 추가 필요
              name: gas.sopGasId + '_p',
              field: gas.sopGasId + '_p',
              label: gas.gasName,
              align: 'center',
              sortable: false,
              child: [
                {
                  name: gas.sopGasId,
                  field: gas.sopGasId,
                  label: gas.safetyStandards,
                  align: 'center',
                  type: 'text',
                  sortable: false,
                  style: 'width:80px',
                },
              ]
            })
          })
        }
      },);
    },
    addGas() {
      let pushData = {
        sopGasCheckId: uid(),  // 가스농도측정번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
        supplementWorkTypeCd: this.supWork.supplementWorkTypeCd,  // 보충작업구분
        checkTime: '',  // 점검시간
        gasCheckMachine: '',  // 점검기기명
        gasCheckUserName: '',
        gasCheckUserId: '',  // 점검자
        gasConfirmUserName: '',
        gasConfirmUserId: '',  // 확인자(입회자)
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        editFlag: 'C',
      }
      this.$_.forEach(this.useGasItems, gas => {
        this.$set(pushData, gas.sopGasId, '0');
      });
      
      this.supWork.gases.push(pushData);
    },
    removeGas() {
      let selectData = this.$refs['gasTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSG0000120', // 삭제할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.supWork.deleteGasChecks) this.supWork.deleteGasChecks = [];
        if (!this.supWork.deleteGasCheckVals) this.supWork.deleteGasCheckVals = [];
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.supWork.deleteGasChecks, { sopGasCheckId: item.sopGasCheckId }) === -1
            && item.editFlag !== 'C') {
            this.supWork.deleteGasChecks.push(item);
            this.$_.forEach(this.useGasItems, gas => {
              this.supWork.deleteGasCheckVals.push({
                sopGasCheckId: item.sopGasCheckId,
                sopGasId: gas.sopGasId
              })
            })
          }
          this.supWork.gases = this.$_.reject(this.supWork.gases, item);
        });
        this.$refs['gasTable'].$refs['compo-table'].clearSelection();
      }
    }, 
    addEntrant() {
      this.popupOptions.title = '사용자 검색'; // 사용자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeEntrantPopup;
    },
    closeEntrantPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (!this.supWork.entrants) this.supWork.entrants = []
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.supWork.entrants, { userId: item.userId }) === -1) {
            this.supWork.entrants.push({
              sopWorkEntrantId: uid(),  // 밀폐 입출입자 번호
              sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
              userId: item.userId,  // 출입자 id
              deptUserName: `${item.deptName} / ${item.userName}`,  // 출입자 소속
              regUserId: this.$store.getters.user.userId,  // 등록자 ID
              editFlag: 'C'
            })
          }
        })
        
        if (this.supWork.editFlag !== 'C') {
          this.supWork.editFlag = 'U'
          this.supWork.chgUserId = this.$store.getters.user.userId
        }
      }
    },
    addEntrantVendor() {
      if (!this.supWork.entrants) this.supWork.entrants = []
      this.supWork.entrants.splice(0, 0, {
        sopWorkEntrantId: uid(),  // 밀폐 입출입자 번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
        userId: '',  // 출입자 id
        deptUserName: '',  // 출입자 소속
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        editFlag: 'C'
      })
        
      if (this.supWork.editFlag !== 'C') {
        this.supWork.editFlag = 'U'
        this.supWork.chgUserId = this.$store.getters.user.userId
      }
    },
    removeEntrant() {
      let selectData = this.$refs['entrantTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '삭제할 행을 지정하세요.', // 삭제할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.supWork.deleteEntrants) this.supWork.deleteEntrants = [];
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.supWork.deleteEntrants, { sopWorkEntrantId: item.sopWorkEntrantId }) === -1
            && item.editFlag !== 'C') {
            this.supWork.deleteEntrants.push(item);
          }
          this.supWork.entrants = this.$_.reject(this.supWork.entrants, item);
        });
        this.$refs['entrantTable'].$refs['compo-table'].clearSelection();

        if (this.supWork.editFlag !== 'C') {
          this.supWork.editFlag = 'U'
          this.supWork.chgUserId = this.$store.getters.user.userId
        }
      }
    },
    // setPermitData() {
    //   this.supWork.issuedDeptCd = this.$_.clone(this.workPermit.issuedDeptCd)
    //   this.supWork.issuedUserId = this.$_.clone(this.workPermit.issuedUserId)
    //   this.supWork.approvalDeptCd = this.$_.clone(this.workPermit.approvalDeptCd)
    //   this.supWork.approvalUserId = this.$_.clone(this.workPermit.approvalUserId)
    //   this.supWork.relationCooperation1DeptCd = this.$_.clone(this.workPermit.relationCooperation1DeptCd)
    //   this.supWork.relationCooperation1UserId = this.$_.clone(this.workPermit.relationCooperation1UserId)
    //   this.supWork.relationCooperation2DeptCd = this.$_.clone(this.workPermit.relationCooperation2DeptCd)
    //   this.supWork.relationCooperation2UserId = this.$_.clone(this.workPermit.relationCooperation2UserId)
    //   this.supWork.maintenanceDeptCheckDeptCd = this.$_.clone(this.workPermit.maintenanceDeptCheckDeptCd)
    //   this.supWork.maintenanceDeptCheckUserId = this.$_.clone(this.workPermit.maintenanceDeptCheckUserId)
    //   this.supWork.maintenanceDeptEntryDeptCd = this.$_.clone(this.workPermit.maintenanceDeptEntryDeptCd)
    //   this.supWork.maintenanceDeptEntryUserId = this.$_.clone(this.workPermit.maintenanceDeptEntryUserId)
    //   if (this.supWork.editFlag !== 'C') {
    //     this.supWork.editFlag = 'U'
    //     this.supWork.chgUserId = this.$store.getters.user.userId
    //   }
    // },
    dataChange() {
      if (this.supWork.editFlag !== 'C') {
        this.supWork.editFlag = 'U'
        this.supWork.chgUserId = this.$store.getters.user.userId
      }
    },
    contentsField(props, col) {
      /**
       * 안전조치사항 항목에서 항목 입력 타입이 '테이블_점검자' 인 경우 테이블에 표시
       * 단, 예전에 '테이블_점검자'였으며 그럼으로 인해 데이터가 저장이 된적이 있는 경우 컴포넌트 표시
       */
      let returnVal = true;
      if (col.name === 'confirmUserName') {
        returnVal = props.row['sopCheckItemKindCd'] === 'SCIK000005' || Boolean(props.row['confirmUserName'])
      } else if (col.name === 'resultContents') {
        returnVal = props.row['sopCheckItemKindCd'] === 'SCIK000010' || Boolean(props.row['resultContents'])
      }
      return returnVal
    },
    tableDataChange(props, col) {
      if (col.name === 'necessaryFlag' && props.row[col.name] !== 'Y') {
        this.$set(props.row, 'confirmFlag', 'N');
      }
    },
    entrantDataChange(props) {
      if (props.row.editFlag !== 'C') {
        props.row.editFlag = 'U'
        props.row.chgUserId = this.$store.getters.user.userId
      }
    },
  }
};
</script>
